export function otaPermissions(role) {
  return {
    manage: role === "admin" || role === "superAdmin",
    operate: role === "superAdmin",
  };
}
export const otaLabels = {
  BASELINE: "当前基线包",
  DRAFT: "草稿",
  APPROVED: "已审核",
  PUBLISHING: "发布中",
  PUBLISHED: "已发布",
  WITHDRAWN: "已撤回",
  ERROR: "发布异常",
  RUNNING: "升级中",
  PAUSED: "已暂停",
  AWAITING_CONTINUE: "等待下一批",
  COMPLETED: "全部确认成功",
  PENDING: "待下发",
  QUEUED: "本批排队，尚未发送",
  DISPATCHING: "正在发送",
  SENT: "已发送，等待设备",
  UNCERTAIN: "发送结果未确认",
  TIMEOUT: "状态超时，结果未确认",
  idle: "空闲",
  precheck: "设备预检查",
  downloading: "下载中",
  verifying: "校验中",
  ready_reboot: "等待重启",
  boot_pending: "新固件启动验证中",
  confirmed: "已确认成功",
  rolled_back: "已回滚",
  failed: "升级失败",
};
export const otaLabel = (value) => otaLabels[value] || value || "—";
export function otaTone(value) {
  if (["confirmed", "COMPLETED", "PUBLISHED"].includes(value)) return "success";
  if (["failed", "rolled_back", "ERROR"].includes(value)) return "danger";
  if (["PAUSED", "UNCERTAIN", "TIMEOUT", "WITHDRAWN"].includes(value))
    return "warning";
  return "info";
}
export function otaTime(value) {
  const time = Number(value);
  return time > 0
    ? new Date(time).toLocaleString("zh-CN", { hour12: false })
    : "—";
}
export function canStartOta(group, settings, role) {
  return (
    otaPermissions(role).operate &&
    settings.dispatchEnabled === true &&
    settings.preview !== true &&
    ["DRAFT", "PAUSED", "AWAITING_CONTINUE"].includes(group.state)
  );
}
